// extracted by mini-css-extract-plugin
export default {"imgPreview":"ThucDonFiles_imgPreview__zQLD4","xButton":"ThucDonFiles_xButton__szD+F"};